import React from 'react';
import { withStyles } from 'material-ui/styles';
import UITuple from '../../core/ui/tuple.js';

const styles = theme => ({
  link : {
    textDecoration: 'none',
    color: 'black',
  },
  title: {
    fontSize: 15,
    lineHeight: '20px',
  },
  block: {
    display: 'block',
    fontSize: 10, 
    lineHeight: '15px',
    textAlign: 'justify',
  },
});


class MoviePiece extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }

  render() {
    const classes = this.props.classes;
    const data = this.props.data;
    const body = 
      <div>
        <a className={classes.link} href={data.link}>
          <div className={classes.title}>Movie</div>
          <hr/>
          <UITuple className={classes.block} title='Name' data={data.name}/>
          <UITuple className={classes.block} title='Summary' data={data.summary}/>
        </a> 
      </div>;    
    return (
      body
    );      
  }
}

export default withStyles(styles)(MoviePiece);


// WEBPACK FOOTER //
// ./src/search/display/movie_piece.js